import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e4ee2e7")

_pushScopeId("data-v-6e4ee2e7")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CalendarKendo = _resolveComponent("CalendarKendo")

  return ($setup.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_CalendarKendo, {
          onOnselectslot: $setup.onselectslot,
          onOnselectvirtualslot: $setup.onselectvirtualslot,
          product: $setup.order.newproduct?.productId,
          selectedDateProp: $setup.order.newproduct?.date ? $setup.order.newproduct?.date + 'T' + $setup.order.newproduct?.startTime : '',
          date: $setup.order.newproduct?.date,
          changeDate: true,
          selectedSlotId: $setup.order.newproduct?.slotId,
          removePastSlots: true
        }, null, 8, ["onOnselectslot", "onOnselectvirtualslot", "product", "selectedDateProp", "date", "selectedSlotId"])
      ]))
    : _createCommentVNode("", true)
})